import React, { useState } from 'react';
import { GiFallingStar } from "react-icons/gi";

const AISearch = () => {
  const [inputText, setInputText] = useState('');
  const [response, setResponse] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleGenerate = async () => {
    if (!inputText.trim()) {
      setError('Input cannot be empty.');
      return;
    }
    setError('');
    setLoading(true);

    try {
      const apiKey = "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";
      const response = await fetch('https://api.deepseek.com/chat/completions', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${apiKey}`,
        },
        body: JSON.stringify({
          model: 'gpt-3.5-turbo',
          messages: [{ role: 'user', content: inputText }],
        }),
      });

      const data = await response.json();
      if (response.ok) {
        const aiResponse = data.choices[0].message.content;
        setResponse(aiResponse);
      } else {
        setError(data.error?.message || 'An error occurred.');
      }
    } catch (err) {
      setError('Failed to fetch the response. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="container">
        <div className="row">
          <div className="col-md-12 text-center">
            <span className="heading_of_gpt_page">AI-Generated UI</span>
            <span className="heading_of_gpt"> on Demand.</span>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12 text-center">
            <p style={{ fontSize: '16px' }}>
              Generate, iterate, and export production-ready UI components, code and designs.
            </p>
          </div>
        </div>
        <br />
        <br />
        <div className="row" style={{ justifyContent: 'center' }}>
          <div className="main_div">
            <input
              type="text"
              className="chat_gpt_input"
              value={inputText}
              onChange={(e) => setInputText(e.target.value)}
              placeholder="Type your query here..."
            />
            <br />
            <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
              <button className="generate_btn" onClick={handleGenerate} disabled={loading}>
                {loading ? 'Generating...' : <><GiFallingStar /> Generate</>}
              </button>
            </div>
          </div>
        </div>
        <div className="row" style={{ justifyContent: 'center', marginTop: '20px' }}>
          {error && <p style={{ color: 'red' }}>{error}</p>}
          {response && (
            <div className="response_box">
              <h5>AI Response:</h5>
              <p>{response}</p>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default AISearch;



// import React from 'react'
// import { GiFallingStar } from "react-icons/gi";

// const AISearch = () => {
//   return (
//     <>
//         <div className="container">
//             <div className="row">
//                 <div className="col-md-12 text-center">
//                 <span className='heading_of_gpt_page'>AI-Generated UI</span> <span className='heading_of_gpt'>on Demand.</span>
//                 </div>
//             </div>
//             <div className="row">
//                 <div className="col-md-12 text-center">
//                     <p style={{fontSize:'16px'}}>Generate, iterate, and export production-ready UI components, code and designs.</p>
//                 </div>
//             </div><br/><br/>
//             <div className='row' style={{justifyContent:"center"}}>
//                 <div className='main_div'>
//                     <input type="text" className='chat_gpt_input'/><br/>
//                     <div style={{display:"flex",justifyContent:"flex-end"}}><button className='generate_btn'><GiFallingStar /> Generate</button></div>
//                 </div>
//             </div>
//         </div>
//     </>
//   )
// }

// export default AISearch